import { SelectInput, Form, Button, ReferenceArrayInput, AutocompleteArrayInput, useDataProvider } from 'react-admin';
import { useMutation } from '@tanstack/react-query';
import { Stack, Box } from '@mui/material';
import { useState, useEffect } from 'react';
//import { useFormContext } from 'react-hook-form';

import ReactECharts from 'echarts-for-react';
//import * as echarts from 'echarts/core';
import { useTheme } from '@mui/material/styles';
//import 'echarts/theme/dark-mushroom';

import dayjs from "dayjs";

import { boxStyle, normalizeFilterForm } from './util';
import DateRangeInput from './DateRangeInput';
import MetricExportButton from './MetricExportButton';
import MetricTotals from './MetricTotals';

const metricChoices = [
	//{ id: 'user', name: 'User' },
	{ id: 'session', name: 'Sessions' },
	{ id: 'registration', name: 'Registrations' }
];

const rangeChoices = [
	{ id: 'today', name: 'Today' },
	{ id: 'yesterday', name: 'Yesterday' },
	{ id: 'week', name: 'Last week' },
	{ id: 'thirty', name: 'Last 30 days' },
	{ id: 'month', name: 'Last Month' },
	{ id: 'custom', name: 'Custom' }

];

export const MetricChart = () => {
	const muiTheme = useTheme();
	const isDark = muiTheme.palette.mode === 'dark';
	const dataProvider = useDataProvider();
	const [data, setData] = useState({});

	const { mutate, isPending } = useMutation({
		mutationFn: async (filter) => {
			normalizeFilterForm(filter);
			return await dataProvider.getAnalytics({ filter });
		},
		onSuccess: ({ data }) => {
			const { analytics } = data;
			setData( analytics );
		}
	});

	// call mutation when component loads
	useEffect(() => {
		mutate({ date_range: 'week' });
	}, [mutate]);

	// eChart docs: https://echarts.apache.org/en/option.html#title
	// Stacked chart: https://echarts.apache.org/examples/en/editor.html?c=bar-stack


	function formatDuration(duration) {
		const sec = duration % 60;
		const min = Math.floor(duration / 60);

		return `${min > 0 ? min + 'm' : ''}${sec > 0 ? sec + 's' : ''}`;
	}

	const legendFormatter = (params) => {
		const out = [
			
		];

		params.forEach( (p) => {
			let entry = '';
			let label = `${p.marker} ${p.seriesName}: `;

			if ( p?.value[1] ) {
				switch( p.seriesId ) {
					case 'session_average':
						entry = label + formatDuration( p.value[1] );
						break;

					default:
						entry = label + p.value[1];
				}
			}

			if ( entry ) {
				out.push( entry );
			}
		});

		return out.join('<br/>');
	};

	const option = {

		tooltip: {
			trigger: "axis",
			formatter: legendFormatter
		},
		legend: {
			padding: 20
		},
		xAxis: {
			type: "time",
			axisLabel: {
				formatter: (value) => dayjs(value).format("M/D/YYYY")
			}
		},
		yAxis: [
			{
				type: "value",
				name: 'Count',
				position: 'right',
				minInterval: 1,
				splitLine: {
					lineStyle: {
						color: '#000',
						type: 'solid'
					}
				}
			},

			// Used by time engaged
			{
				type: "value",
				name: 'Duration',
				position: 'left',
				splitLine: {
					lineStyle: {
						type: 'dashed',
						color: '#ccc'
					}
				},
				axisLabel: {
					formatter: (value) => formatDuration(value)
				}
			}
		],
		series: data?.series

	};

	return (
		<>
			<Form onSubmit={mutate} disabled={isPending}>
				<Stack direction="row" spacing={2} alignItems={"center"} flexWrap="wrap">
					<ReferenceArrayInput source="session_id" reference="sessions" perPage={100} sort={{ field: 'name', order: 'ASC' }}>
						<AutocompleteArrayInput label="Session(s)" fullWidth={false} />
					</ReferenceArrayInput>
					<AutocompleteArrayInput source="metrics" choices={metricChoices} fullWidth={false} helperText="Leave blank for all metrics" />
					<SelectInput source="date_range" defaultValue={"week"} choices={rangeChoices} fullWidth={false} />
					<DateRangeInput />

					<Button type="submit" label="Filter" />
					<MetricExportButton />
				</Stack>
			</Form>

			<Stack direction={{ sm: 'column', md: 'row' }} spacing={2} alignItems={"stretch"}>
				<Box sx={{...boxStyle, 	width: { sm: '100%', md: .75 } }}>
					<ReactECharts option={option} notMerge theme={isDark ? 'dark' : undefined} autoResize />
				</Box>
				<MetricTotals sx={boxStyle} totals={data.totals} />				
			</Stack>

		</>
	);
}